import UsersList from "./UsersList";
import GroupSharpIcon from '@material-ui/icons/GroupSharp';
import AddUser from "./UserCreate";
import EditUser from "./UserEdit";
import ShowUser from "./UserView";

export default {
    list: UsersList,
    create: AddUser,
    edit: EditUser,
    show: ShowUser,
    icon: GroupSharpIcon
}